<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <label class="label">{{$t('callTasks.testCallsByCampaign')}} {{campaign.name}}</label>
          <div class="jump-target">
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th>{{$t('callTasks.phone')}}</th>
                <th>{{$t('callTasks.state')}}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="calltask in calltasks">
                <td>
                  <a :href="'#/callTasksTestResult/'+$props.id+'/'+calltask.id">{{calltask.phone}}</a>
                </td>
                <td>
                  {{getCallTaskState(calltask.state)}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
            <back-to-top target=".jump-target">
              <button class="button">{{$t('common.up')}}</button>
            </back-to-top>
          </div>
          <p class="control">
            <button class="button is-light" v-on:click="cancel">
              <span class="icon">
                <i class="fa fa-times-circle"></i>
              </span>
              <span>{{$t('common.actions.close')}}</span>
            </button>
          </p>
        </article>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex'
  import { BackToTop } from 'vue-bulma-jump'
  import Vue from 'vue'
  import CheckToken from '../authentication/CheckToken'
  import GetCalltaskState from './GetCalltaskState'

  Vue.mixin(CheckToken)
  Vue.mixin(GetCalltaskState)

  const CALLTASKS_API = '/outgoing-cpg-sec'
  const CAMPAIGNS_API = '/api/campaigns'

  export default {
    props: ['id'],
    components: {
      BackToTop
    },
    data () {
      return {
        calltasks: [],
        campaign: ''
      }
    },
    created: function () {
      this.checkToken()
      this.calltasks = this.loadData()
      this.loadCampaign()
    },
    computed: {
      ...mapGetters([
        'authenticationToken',
        'loggedId'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      loadApplications () {
          this.loadData()
      },
      loadData () {
        let that = this
        this.$http.get(CALLTASKS_API + '/test/' + this.$props.id, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.calltasks = response.data
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', that.$i18n.messages[that.$i18n.locale].notifications.callTasks.errorLoadTestCallsPhoneNumbers)
          })
      },
      loadCampaign () {
        this.$http.get(CAMPAIGNS_API + '/' + this.$props.id, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.campaign = response.data
          })
      },
      cancel () {
        this.$router.push('/campaigns/' + this.$props.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TestCalltasksCampaign.vue?02647f76